import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { CREATIVE_LIBRARY_REPORT_ID } from 'modules/campaigns/modules/campaigns-reports/config/reports/creative-library/creativeLibraryReportId';
import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';

const defaultColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.IS_ACTIVE.field,
    FIELDS.THUMBNAIL_URL.field,
    FIELDS.CUSTOM_CREATIVE_NAME.field,
    FIELDS.AD_GROUPS_ASSIGNMENT.field,
    FIELDS.ID.field,
    FIELDS.STATUS.field,
    FIELDS.CONTENT.field,
    FIELDS.URL.field,
    FIELDS.CHANNEL_TYPE.field,
    FIELDS.FORMAT.field,
    FIELDS.SIZE.field,
    FIELDS.CREATIVE_ORIENTATION.field,
    FIELDS.CREATE_TIME.field,
    FIELDS.CUSTOM_ID.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(CREATIVE_LIBRARY_REPORT_ID, field));

export { defaultColumns };
